import React from 'react';
import logo from 'assets/img/biz-capital-logo-2019.png';
import './bizon-screen-wrapper.styles.scss';

const BizonScreenWrapper: React.FC = ({ children }): JSX.Element => {
    return (
        <div className="bizon-screen-wrapper">
            <div className="bizon-screen-wrapper__header">
                <div className="bizon-screen-wrapper__logo grid-container">
                    <img src={logo} alt="bizcap-logo" />
                </div>
            </div>
            <div className="bizon-screen-wrapper__content">
                {children}
            </div>
        </div>
    );
};

export default BizonScreenWrapper;
